var map = {
	"./cs.json": [
		68645,
		68645
	],
	"./de.json": [
		60808,
		60808
	],
	"./en.json": [
		64724,
		64724
	],
	"./es.json": [
		48339,
		48339
	],
	"./fr.json": [
		85487,
		85487
	],
	"./it.json": [
		1786,
		1786
	],
	"./ja.json": [
		79266,
		79266
	],
	"./ko.json": [
		80974,
		58593
	],
	"./pl.json": [
		99351,
		99351
	],
	"./pt-br.json": [
		39734,
		39734
	],
	"./pt.json": [
		65519,
		65519
	],
	"./ru.json": [
		67062,
		67062
	],
	"./tr.json": [
		42449,
		42449
	],
	"./zh.json": [
		80341,
		80341
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 44118;
module.exports = webpackAsyncContext;